import { Box, Typography } from "@mui/material"

import { Container, Pagination, TeaserCard, type FC } from ".."
import type { TeaserCardProps } from "../TeaserCard/TeaserCard"

type TeaserCollectionProps = {
  title?: string
  cards: TeaserCardProps[]
  currentPage?: number
  pages?: number
  onPageChange?: (pageNumber: number) => void
}

const TeaserCollection: FC<TeaserCollectionProps> = ({
  title,
  cards = [],
  currentPage,
  pages,
  onPageChange,
}) => {
  if (!Array.isArray(cards)) return null

  const showPagination = currentPage && pages && pages > 1

  return (
    <Container maxWidth={1520} pb={{ xs: 20, md: 45 }}>
      {title && (
        <Box pt={{ xs: 16, md: 40 }} pb={{ xs: 8, md: 12 }}>
          <Typography variant="heading.lg" component="h2">{title}</Typography>
        </Box>
      )}
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: "repeat(2, minmax(0, 1fr))",
          md: "repeat(3, minmax(0, 1fr))",
          xl: "repeat(4, minmax(0, 1fr))",
        }}
        columnGap={{ xs: 3, md: 5 }}
        rowGap={{ xs: 3, md: 5 }}
      >
        {cards.map((card, i) => (
          <TeaserCard key={card.title || card.link?.uri || `teaser-${i}`} {...card} />
        ))}
      </Box>
      {showPagination && (
        <Box pt={{ xs: 15, md: 20 }}>
          <Pagination page={currentPage} count={pages} onPageChange={onPageChange} />
        </Box>
      )}
    </Container>
  )
}
export default TeaserCollection
